import { Component, Input, OnInit } from '@angular/core';
import { BonDto, ComptageDto, ComptageLigneDto, ComptageLignesLexiClient } from '@lexi-clients/lexi';
import { ExportingEvent } from 'devextreme/ui/data_grid';
import { ExportDataGridService } from 'lexi-angular/src/app/shared/services/export-data-grid.service';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-bon-detail-tracabilite',
    templateUrl: './bon-detail-tracabilite.component.html',
    styleUrls: ['./bon-detail-tracabilite.component.scss'],
    standalone: false
})
export class BonDetailTracabiliteComponent implements OnInit {
  @Input("bon") bon : BonDto;
  @Input("comptages") comptages : ComptageDto[];

  comptageLignes : ComptageLigneDto[] = [] ;
  storageKey = "grille_bon_lignes_tracabilite";

  constructor(
    private readonly comptageLignesLexiClient: ComptageLignesLexiClient,
    private readonly exportDataGridService: ExportDataGridService

  ) { }

  async ngOnInit() {
    await this.setDataSource();
  }

  onExporting(e: ExportingEvent) {
    let filename = `informations-tracabilite-bon-${this.bon?.id}`;
    this.exportDataGridService.onExporting(e, filename);
  }

  async setDataSource(){
    this.comptageLignes =  await lastValueFrom(this.comptageLignesLexiClient.getLatestComptageLignesByBonId(this.bon.id));
  }
}
